<template>
	<main class="login" :login-state="loginState">
		<section>
			<div class="branding">
				<figure class="logo" alt="PTC Wizard Logo">
					<Logo />
				</figure>
				<div class="school-name">PTC Wizard Agent Login</div>
			</div>
			<div class="card">
				<form
					class="needs-validation"
					v-if="!showForgotPass"
					:class="{ 'was-validated': toggleValidation, failed: toggleFail }"
					novalidate=""
					@submit.prevent="login"
				>
					<h4 class="card-header">Sign in</h4>
					<div class="card-body">
						<!-- <div class="form-floating" field="Email">
							<input
								type="text"
								class="form-control form-control-lg"
								id="floatingInput"
								placeholder="PTC Wizard Email"
								v-model="username"
								required
								data-cy="login-username"
							/>
							<label for="floatingInput">Username</label>
						</div> -->
						<!-- <div class="form-floating" field="password">
							<input
								type="password"
								class="form-control form-control-lg"
								id="floatingPassword"
								placeholder="Password"
								v-model="password"
								required
								data-cy="login-password"
							/>
							<label for="floatingPassword">Password</label>
						</div> -->
						<!-- <button class="submit" :disabled="toggleSubmit" data-cy="login-submit-btn">
              <i class="bi bi-lock opacity-50"></i>
              <span>Sign in</span>
            </button> -->
						<div class="alert alert-danger px-5 mt-2" v-if="toggleFail">
							Authentication Failed. Please try again or contact your school for help
							signing in.
						</div>
						<div class="sso">
							<!-- <div class="caps">Or sign in with</div> -->
							<div class="hstack">
								<button
									class="btn"
									:disabled="toggleSubmit"
									type="button"
									@click="signinWithGoogle"
								>
									<LogoGoogle />
									<span>Google</span>
								</button>
							</div>
						</div>
					</div>
				</form>
			</div>
			<small class="text-muted vstack gap-1">
				<strong class="opacity-50">Parent Teacher Conference Scheduling Made Easy</strong>
				<div>
					&copy;2006 - {{ new Date().getFullYear() }} PTC Wizard, All rights reserved.
				</div>
			</small>
		</section>
	</main>
</template>

<script setup>
import AuthService from "@/services/auth.service";
import { useAuthenticationStore } from "@/stores/authentication";
import { useSchoolStore } from "@/stores/school";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";

import Logo from "@/assets/icons/logo-vertical-regular.svg";

import LogoGoogle from "@/assets/brand/google.svg";
import { computed } from "vue";

const router = useRouter();
const route = useRoute();
const authenticationStore = useAuthenticationStore();
const schoolStore = useSchoolStore();
const school = ref({});
// const route = useRoute()
//   const loading = ref(true);
//   const error = ref(null);
const username = ref(null);
const password = ref(null);
const passwordReminderEmail = ref(null);
const passwordReminderSent = ref(false);
const passwordError = ref(false);
const showForgotPass = ref(false);
const googleUrl = ref(null);

function signinWithGoogle() {
	toggleSubmit.value = true;
	// console.log(googleUrl.value);
	authenticationStore.googleUrl("support", "support", "support").then((response) => {
		console.log(response);
		googleUrl.value = response;
		window.location.href = googleUrl.value;
	});
	return true;
}

function login() {
	toggleValidation.value = true;
	toggleSubmit.value = true;
	authenticationStore
		.login({
			username: username.value,
			password: password.value,
			account: school.value.subdomain,
			district_id: school.value.district_id,
		})
		.then((response) => {
			if (response) {
				console.log("Login Successful");
				// authenticationStore.fetchProfile().then((response) => {
				router.push({ name: "support-accounts" });
				// });
			} else {
				console.log("Login Failed");
				toggleFail.value = true;
				toggleSubmit.value = false;
			}
		});
}

const loginState = ref("default");
const toggleValidation = ref(false);
const toggleSubmit = ref(false);
const toggleFail = ref(false);
</script>
